module.exports = __webpack_public_path__ + "img/b.57c4eb89.jpg";